import { render, staticRenderFns } from "./Milestones.vue?vue&type=template&id=4ccbba2c&scoped=true&"
import script from "./Milestones.vue?vue&type=script&lang=ts&"
export * from "./Milestones.vue?vue&type=script&lang=ts&"
import style0 from "./Milestones.vue?vue&type=style&index=0&id=4ccbba2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccbba2c",
  null
  
)

export default component.exports